'use client'

import clsx from 'clsx'
import s from './style.module.css'

type Props = {
  showBackdrop: boolean
  onClick: () => void
  className?: string
}

const Backdrop = ({showBackdrop, onClick, className}: Props) => {
  return <div className={clsx({[s.backdrop]: showBackdrop}, className)} onClick={onClick} />
}

export default Backdrop
